import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { GodkjenningProsessResponse } from '@klp/prosjekt/interfaces';
import type { HideProsjektOptionsElementType } from '../MenuPopper/MenuPopperProjectOptions';
import type { ProsjektSteg } from '@klp/formgenerator/interfaces';
import { ExpandMore } from '@material-ui/icons';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { ProsjektActionsList } from './ProsjektActionsList';
import { useFormAuth } from '@klp/formgenerator/hooks';

const styles = () => ({
    accordion: {
        padding: 0,
    },
    list: { width: '100%' },
});

export type HideActionsElementType = HideProsjektOptionsElementType;
type ProsjektActionsProps = {
    prosjekt: GodkjenningProsessResponse;
    isEDAdmin: boolean | undefined;
    allowedSteps: Array<ProsjektSteg> | undefined;
    selectedElement?: HideActionsElementType;
    navigateOnDelete?: boolean;
};

export const ProsjektActions: React.FC<ProsjektActionsProps> = ({
    isEDAdmin = false,
    prosjekt,
    allowedSteps,
    selectedElement,
    navigateOnDelete = false,
}) => {
    const { t } = useTranslation();
    const { currentAktivitet, stegNavn } = prosjekt;
    const classes = useKlpStyles({}, styles);

    const { isActivityEditable } = useFormAuth();
    const [accordionExpanded, setAccordionExpanded] = React.useState(() =>
        currentAktivitet ? !isActivityEditable(currentAktivitet) : true,
    );

    const handleAccordionChange = () => {
        setAccordionExpanded(!accordionExpanded);
    };

    return (
        <Accordion
            className={classes.accordion}
            data-testid="ProsjektActionsAccordion"
            expanded={accordionExpanded}
            onChange={handleAccordionChange}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                {t('prosjekt.table.actionMenuItems.currentHeader', {
                    stegNavn: stegNavn,
                })}
            </AccordionSummary>
            <AccordionDetails>
                <ProsjektActionsList
                    prosjekt={prosjekt}
                    isEDAdmin={isEDAdmin}
                    allowedSteps={allowedSteps}
                    selectedElement={selectedElement}
                    navigateOnDelete={navigateOnDelete}
                />
            </AccordionDetails>
        </Accordion>
    );
};
